import React from 'react';
import { Router, useHistory } from "react-router-dom";
import { createBrowserHistory } from "history";
import "./App.css";
//custom
import { defaultTheme } from "./theme";
import { TranslateProvider } from "./i18n";
//date
import moment from "moment";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import "moment/locale/zh-cn";
//material-ui
import { ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { Routes } from "./Routes";
import { SnackbarProvider, useSnackbar } from 'notistack';
import { CurlProvider } from "zh-common-modules";
import { clearStorage, IS_DEV } from "utils";
moment.locale("zh-cn");

function ProviderWrapper(props){
  const { children } = props;
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

	const resResponse = (response, res, rej) => {
		const { data } = response;
		const { success, message, content } = data;
		if (success) {
			if (message) {
				enqueueSnackbar(message, {
					variant: "success"
				});
			}
			res(content);
		}
		else {
			enqueueSnackbar(message, {
				variant: "error"
			});
			rej();
		}
  };
  
  const errorHandle = (error, rej) => {
		const { status } = error.response || { status: "unknown" };
		let statusText = "";
		let variant = "error";
		switch (status) {
			case 404:
				statusText = "请求地址有误";
        break;
      case 401:
        statusText = "身份过期，请重新登陆。";
        break;
			default:
				statusText = `错误(${status})!`;
				break;
		}
		enqueueSnackbar(statusText, {
			variant
    });
    rej(error);
    if(status === 401){
      clearStorage();
      history.push("/sign-in");
    }
  };
  
  const requestInterceptors = (request) => {
    const token = localStorage.getItem("auth");
    if(token) request.headers["auth"] = token;
    return request;
  }

  return (
    <CurlProvider
      responseHandle={resResponse}
      errorHandle={errorHandle}
      auth={() => true}
      configs={{
        baseUrl : IS_DEV ? "" : "",
        requestInterceptors
      }}
    >
      { children }
    </CurlProvider>
  )
}


function App() {
    const BASE_NAME = window.__POWERED_BY_QIANKUN__ ? "/app/Supplier" : "";
    const browserHistory = createBrowserHistory({
      basename: BASE_NAME
    });
    return (
      <ThemeProvider theme={defaultTheme}>
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={"zh-cn"}>
          <TranslateProvider locale={"zh-CN"}>
            <SnackbarProvider anchorOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}>
              <CssBaseline>
                <Router history={browserHistory}>
                  <ProviderWrapper>
                    <Routes index={"/authentication-list"}/>
                  </ProviderWrapper>
                </Router>
              </CssBaseline>
            </SnackbarProvider>
          </TranslateProvider>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    );
}

export default App;